import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Car, Users, KeyRound, FileText, ShieldCheck, Wrench,
  AlertTriangle, Fuel, Wallet, CalendarClock, FolderOpen, BarChart3, Settings, Gavel, FileSpreadsheet,
} from "lucide-react";
import { Logo } from "@/components/Logo";

export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/vehicles", label: "Véhicules", icon: Car, testid: "nav-vehicles" },
  { to: "/drivers", label: "Conducteurs", icon: Users, testid: "nav-drivers" },
  { to: "/assignments", label: "Affectations", icon: KeyRound, testid: "nav-assignments" },
  { to: "/contracts", label: "Contrats", icon: FileText, testid: "nav-contracts" },
  { to: "/insurances", label: "Assurances", icon: ShieldCheck, testid: "nav-insurances" },
  { to: "/maintenance", label: "Entretiens", icon: Wrench, testid: "nav-maintenance" },
  { to: "/accidents", label: "Sinistres", icon: AlertTriangle, testid: "nav-accidents" },
  { to: "/contraventions", label: "Contraventions", icon: Gavel, testid: "nav-contraventions" },
  { to: "/fuel", label: "Carburant & Recharge", icon: Fuel, testid: "nav-fuel" },
  { to: "/expenses", label: "Dépenses", icon: Wallet, testid: "nav-expenses" },
  { to: "/deadlines", label: "Échéances", icon: CalendarClock, testid: "nav-deadlines" },
  { to: "/documents", label: "Documents", icon: FolderOpen, testid: "nav-documents" },
  { to: "/reports", label: "Rapports", icon: BarChart3, testid: "nav-reports" },
  { to: "/convertisseur", label: "TOTAL ENERGIE", icon: FileSpreadsheet, roles: ["admin", "fleet_manager"], testid: "nav-convertisseur" },
  { to: "/admin", label: "Administration", icon: Settings, roles: ["admin"], testid: "nav-admin" },
];

const DRIVER_NAV = ["/", "/vehicles", "/contraventions", "/deadlines", "/documents"];

export const SidebarContent = ({ role, onNavigate }) => (
  <div className="flex h-full flex-col bg-[#001A3B]">
    <div className="flex h-16 items-center border-b border-white/10 px-5">
      <Logo variant="dark" />
    </div>
    <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
      {NAV.filter((n) => (!n.roles || n.roles.includes(role) || role === "admin") && !(role === "driver" && !DRIVER_NAV.includes(n.to))).map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          end={n.end}
          onClick={onNavigate}
          data-testid={n.testid}
          className={({ isActive }) =>
            `group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all duration-200 ${
              isActive
                ? "bg-[#0A2A52] text-white"
                : "text-[#9FB2CE] hover:bg-white/5 hover:text-white"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <span className={`h-5 w-0.5 rounded-full transition-all ${isActive ? "bg-[#A5894E]" : "bg-transparent"}`} />
              <n.icon className="h-[18px] w-[18px] shrink-0" />
              <span className="truncate">{n.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
    <div className="border-t border-white/10 px-5 py-4">
      <p className="text-[10px] uppercase tracking-widest text-[#6B82A5]">Gestion de flotte</p>
      <p className="mt-1 text-xs text-[#93A6C4]">© 2026 Omer-Decugis &amp; Cie</p>
    </div>
  </div>
);
